import gql from 'graphql-tag';

const getPhotoManagerSubscriptionItems = gql`
  query getPhotoManagerSubscriptionItems {
    photoManagerSubscriptionItems {
      id
      billing_period
      days
      price {
        value
        currency
      }
      trial_days
    }
  }
`;

export default getPhotoManagerSubscriptionItems;
